module.exports = __webpack_public_path__ + "img/ortho.e169bd03.png";